import React from 'react';

const FooterAction = ({ text, onClick }) => (
    <div className="row my-3">
        <div className="col" />
        <div className="col-4">
            <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={onClick}>
                {text}
            </button>
        </div>
        <div className="col" />
    </div>
);

export default FooterAction;
